module.exports = __webpack_public_path__ + "img/pr-10.410c48b4.png";